import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { STEPS } from "@/data/content";
import { SectionHeader, CTAButton } from "@/components/ui-bits";
import { Reveal, staggerParent, staggerChild } from "@/components/motion-primitives";

export const HowItWorks = () => (
  <section className="relative py-24 md:py-32 bg-muted/40 overflow-hidden">
    <div className="container mx-auto px-4 md:px-8">
      <SectionHeader center overline="How It Works" title="A simple, managed process" subtitle="Four clear steps from your first enquiry to ongoing follow-up." />

      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative"
      >
        <div className="hidden lg:block absolute top-8 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-secondary/40 to-transparent" />
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div key={i} variants={staggerChild} data-testid={`step-${i}`} className="relative text-center">
              <div className="relative mx-auto flex items-center justify-center w-16 h-16 rounded-2xl bg-white border border-slate-200 shadow-sm z-10">
                <Icon className="w-6 h-6 text-secondary" />
                <span className="absolute -top-2 -right-2 flex items-center justify-center w-7 h-7 rounded-full bg-primary text-white text-xs font-bold font-mono">
                  {i + 1}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-semibold text-primary">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed max-w-[240px] mx-auto">{s.text}</p>
            </motion.div>
          );
        })}
      </motion.div>

      <Reveal delay={0.1} className="mt-14 text-center">
        <CTAButton href="#quote" variant="primary" size="lg" icon={ArrowRight} testId="how-it-works-cta">Start Your Municipal Query</CTAButton>
      </Reveal>
    </div>
  </section>
);
